import React from 'react';
import { motion } from 'framer-motion'
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../lib/context';

const NavModuleAnimatingBG = observer(({routeName}) => {
    const {uiStore: {navModule__collapsed, isMobile}, articleQueryStore: {isSearching}} = useStore()

    return (
        <motion.div 
            layout
            key="nav--bg"
            className="nav--bg"
            transition={{
                layout: { duration: 0.3, delay: .05}
            }}
            style={{ borderRadius: isMobile ? 30 : 36 }}
        >

            <style jsx global>{`
                .nav--bg {
                    position: absolute;
                    top: 0;
                    left:0;
                    bottom: 0;
                    right: 0;
                    background: rgba(180,180,180,.7);
                    backdrop-filter: blur(5px);
                    // contain: strict;
                }
            `}</style>
        </motion.div>
    )
})

export default NavModuleAnimatingBG